export default __webpack_public_path__ + "static/media/home-page-report-an-issue.52bb307b.jpg";